import { css } from "@emotion/react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import AccountSettingsMenu from "./AccountSettingsMenu";
export function AccountSettingsLayout() {
    return (
        <>
            <Helmet>
                <title>Account Settings - Podtrac</title>
            </Helmet>
            <div
                css={css`
                    display: flex;
                    min-height: 100%;
                    gap: 2rem;
                `}
            >
                <AccountSettingsMenu />
                <div style={{ flex: 1 }}>
                    <Outlet />
                </div>
            </div>
        </>
    );
}
